module.exports = __webpack_public_path__ + "img/operator_status_hover.42957c27.svg";